import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Save } from "lucide-react";
import { api, formatApiError } from "@/api";

const HomeStatRow = ({ stat }) => {
  const queryClient = useQueryClient();
  const [form, setForm] = useState(stat);
  const [error, setError] = useState("");

  useEffect(() => setForm(stat), [stat]);

  const mutation = useMutation({
    mutationFn: (payload) => api.put(`/home-stats/${stat.id}`, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["home-stats"] });
      queryClient.invalidateQueries({ queryKey: ["admin-home-stats"] });
    },
    onError: (requestError) => setError(formatApiError(requestError)),
  });

  const update = (key, value) => setForm({ ...form, [key]: value });

  return <form className="stat-editor-row" onSubmit={(event) => { event.preventDefault(); mutation.mutate({ value: form.value, label_en: form.label_en, label_hi: form.label_hi }); }} data-testid={`admin-home-stat-form-${stat.id}`}>
    <div className="stat-editor-title" data-testid={`admin-home-stat-title-${stat.id}`}>{stat.id}</div>
    <label>Value<input value={form.value} onChange={(event) => update("value", event.target.value)} data-testid={`admin-home-stat-value-input-${stat.id}`} /></label>
    <label>English label<input value={form.label_en} onChange={(event) => update("label_en", event.target.value)} data-testid={`admin-home-stat-english-input-${stat.id}`} /></label>
    <label>Hindi label<input value={form.label_hi} onChange={(event) => update("label_hi", event.target.value)} data-testid={`admin-home-stat-hindi-input-${stat.id}`} /></label>
    {error && <p className="form-error" data-testid={`admin-home-stat-error-${stat.id}`}>{error}</p>}
    <button className="enroll-button stat-save-button" data-testid={`admin-home-stat-save-${stat.id}`}><Save size={16} />{mutation.isPending ? "Saving…" : "Save"}</button>
  </form>;
};

export const HomeStatsEditor = ({ stats }) => <div className="home-stats-editor" data-testid="admin-home-stats-editor">{stats.map((stat) => <HomeStatRow key={stat.id} stat={stat} />)}</div>;